export const SENIORITY_OPTIONS = [
  { id: "owner", label: "Owner" },
  { id: "founder", label: "Founder" },
  { id: "c_suite", label: "C-Suite" },
  { id: "partner", label: "Partner" },
  { id: "vp", label: "VP" },
  { id: "head", label: "Head" },
  { id: "director", label: "Director" },
  { id: "manager", label: "Manager" },
  { id: "senior", label: "Senior" },
  { id: "entry", label: "Entry" },
  { id: "intern", label: "Intern" },
] as const;

export const EMAIL_STATUS_OPTIONS = [
  { id: "verified", label: "Verified" },
  { id: "unverified", label: "Unverified" },
  { id: "likely to engage", label: "Likely to engage" },
  { id: "unavailable", label: "Unavailable" },
] as const;

export const EMPLOYEE_RANGES = [
  { id: "1,10", label: "1–10" },
  { id: "11,50", label: "11–50" },
  { id: "51,200", label: "51–200" },
  { id: "201,500", label: "201–500" },
  { id: "501,1000", label: "501–1K" },
  { id: "1001,5000", label: "1K–5K" },
  { id: "5001,10000", label: "5K–10K" },
  { id: "10001,10000000", label: "10K+" },
] as const;
